<template>
  <div class="dwp-space-y-10 dwp-p-16">
    <div class="dwp-text-center">
      <div class="dwp-text-4xl dwp-text-primary dwp-font-medium">Welcome!</div>
      <div class="dwp-text-gray-600">Let's get this thing done!</div>
    </div>
    <WebDesign class="dwp-max-w-full" />
    <div class="dwp-space-y-4">
      <div class="dwp-flex dwp-items-center dwp-justify-center dwp-space-x-2">
        <VButton type="primary" @click.native="importModal = true">Import List</VButton>
        <VButton type="outline" @click.native="createModal = true">Create List</VButton>
      </div>
      <div class="dwp-flex dwp-items-center dwp-justify-center dwp-space-x-2">
        <VButton type="plain" size="tiny" @click.native="signOut">Sign Out</VButton>
      </div>
    </div>
  </div>
</template>

<script>
import { sync, call } from "vuex-pathify";
import VButton from "@/components/ui/VButton.vue";
import WebDesign from "@/components/illustrations/Web-Design.vue";

export default {
  components: {
    VButton,
    WebDesign
  },
  computed: {
    createModal: sync("ui/modal@list.new.open"),
    importModal: sync("ui/modal@list.import.open")
  },
  methods: {
    ...call("user", ["signOut"])
  }
};
</script>